import { create } from 'zustand';
import api from '@/lib/api';

type Prefs = Record<string, unknown>;

interface PreferencesState {
  prefs: Prefs;
  loaded: boolean;
  fetch: () => Promise<void>;
  setPref: <T>(key: string, value: T) => Promise<void>;
  getPref: <T>(key: string) => T | undefined;
  deletePref: (key: string) => Promise<void>;
  reset: () => void;
}

export const usePreferencesStore = create<PreferencesState>((set, get) => ({
  prefs: {},
  loaded: false,

  fetch: async () => {
    try {
      const r = await api.get('/users/me/preferences');
      set({ prefs: r.data.preferences ?? {}, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },

  setPref: async (key, value) => {
    set(state => ({ prefs: { ...state.prefs, [key]: value } }));
    await api.patch('/users/me/preferences', { [key]: value });
  },

  getPref: <T>(key: string) => get().prefs[key] as T | undefined,

  deletePref: async (key) => {
    const next = { ...get().prefs };
    delete next[key];
    set({ prefs: next });
    await api.patch('/users/me/preferences', { [key]: null });
  },

  reset: () => set({ prefs: {}, loaded: false }),
}));
